
(function() {
  'use strict';

  function initFooterAccordion() {
    const accordions = document.querySelectorAll('.new-footer .footer-accordion');
    if (!accordions.length) return;
 
    function toggleAccordion(heading) { 
      if (window.innerWidth >= 750) return;

      const isActive = heading.classList.contains('active');
      const panel = heading.nextElementSibling;
      if (!panel) return;
 
      heading.setAttribute('aria-expanded', !isActive);
      panel.setAttribute('aria-hidden', isActive);
 
      heading.classList.toggle('active');
 
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }
 
    accordions.forEach(function(heading, index) { 
      const panel = heading.nextElementSibling;
      if (panel) { 
        const panelId = panel.id || `footer-panel-${index}`;
        if (!panel.id) {
          panel.id = panelId;
        }
        heading.setAttribute('aria-expanded', 'false');
        heading.setAttribute('aria-controls', panelId);
        panel.setAttribute('aria-hidden', 'true');
      }
 
      heading.addEventListener('click', function(e) {
        e.preventDefault();
        toggleAccordion(heading);
      });
 
      heading.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(heading);
        }
      });
    });
 
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() { 
        if (window.innerWidth >= 750) {
          accordions.forEach(function(heading) {
            const panel = heading.nextElementSibling;
            if (panel) {
              heading.classList.remove('active');
              heading.setAttribute('aria-expanded', 'false');
              panel.style.maxHeight = null;
              panel.setAttribute('aria-hidden', 'false');
            }
          });
        }
      }, 100);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordion);
  } else {
    initFooterAccordion();
  }
})();

